import styled from 'styled-components'
import { ButtonWidth } from '../Button'

type props = {
  buttonWidth: ButtonWidth
}

export const StyledBox = styled.div<props>`
  width: ${({ buttonWidth }) => buttonWidth}px;
  height: ${({ buttonWidth }) => buttonWidth * 0.6}px;
  display: inline-block;
  position: relative;
`

StyledBox.displayName = 'StyledBox'
